import { MouseEvent, ReactElement } from 'react';

import Input from '@/common/Input';
import Table from '@/common/Table';
import { VehiclesTypes } from '@/features/Vehicles/types';
import { getVehicleTableGridTemplateColumns } from './utils';
import { useVehiclesState } from '@/features/Vehicles';

const VehicleTableHeader = (): ReactElement => {
  const [{ sortBy, sortDirection, allSelected, onSelectAll, settings }, setState] = useVehiclesState(({ state, setState }) => [
    {
      sortBy: state.table.sorting.column,
      sortDirection: state.table.sorting.direction,
      allSelected: state.vehicles.length > 0 && state.selected.length === state.vehicles.length,
      onSelectAll: (): void =>
        setState((current) => ({
          ...current,
          selected: current.selected.length === current.vehicles.length ? [] : current.vehicles.map((v) => v.id),
        })),
      settings: state.settings,
    },
    setState,
  ]);

  const handleSort =
    (column: string) =>
    (event: MouseEvent): void => {
      event.preventDefault();
      event.stopPropagation();
      const isSameColumn = sortBy === column;
      let newDirection: 'asc' | 'desc' | undefined;
      if (!isSameColumn) {
        newDirection = 'asc';
      } else if (sortDirection === 'asc') {
        newDirection = 'desc';
      } else if (sortDirection === 'desc') {
        newDirection = undefined;
      } else {
        newDirection = 'asc';
      }
      setState((current) => ({
        ...current,
        table: {
          ...current.table,
          sorting: { column, direction: newDirection },
        },
      }));
    };

  const sorting = (key: string): { direction: VehiclesTypes.Table['sorting']['direction']; onSort: (event: MouseEvent) => void } => ({
    direction: sortBy === key ? sortDirection : undefined,
    onSort: handleSort(key),
  });

  const gridTemplateColumns = getVehicleTableGridTemplateColumns(settings);

  return (
    <Table.Row header style={{ gridTemplateColumns }}>
      {settings.columns.SELECT && (
        <Table.Cell className="SELECT">
          <Input type="checkbox" onClick={onSelectAll} checked={allSelected} />
        </Table.Cell>
      )}
      {settings.columns.TAG && (
        <Table.Cell className="TAG" sorting={sorting('licensePlate')}>
          TAG
        </Table.Cell>
      )}
      {settings.columns.VIN && (
        <Table.Cell className="VIN" sorting={sorting('vin')}>
          VIN
        </Table.Cell>
      )}
      {settings.columns.VEHICLE_NO && (
        <Table.Cell className="VEHICLE-NO" sorting={sorting('trackingId')}>
          VEHICLE NO.
        </Table.Cell>
      )}
      {settings.columns.AIRPORT && (
        <Table.Cell className="AIRPORT" sorting={sorting('airportCodes')}>
          AIRPORT
        </Table.Cell>
      )}
      {settings.columns.EXCHANGE_PLACE && (
        <Table.Cell className="EXCHANGE-PLACE" sorting={sorting('location.name')}>
          EXCHANGE PLACE
        </Table.Cell>
      )}
      {settings.columns.PHONE && (
        <Table.Cell className="PHONE" sorting={sorting('phoneNumber')}>
          PHONE
        </Table.Cell>
      )}
      {settings.columns.STATUS && (
        <Table.Cell className="STATUS" sorting={sorting('active')}>
          STATUS
        </Table.Cell>
      )}
    </Table.Row>
  );
};

export default VehicleTableHeader;
